var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23783_290968)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.5)",
    fill: "#24A57F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_23783_290968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6741 9.45682C14.6741 10.1811 14.3677 10.8217 13.8663 11.3231C13.3092 11.8802 12.5014 12.0195 12.5014 12.493C12.5014 13.1337 13.532 12.9387 14.5209 13.9276C15.1755 14.5822 15.5794 15.4457 15.5794 16.4485C15.5794 18.4262 13.9916 20 12 20C10.0083 20 8.42059 18.4262 8.42059 16.4485C8.42059 15.4457 8.82449 14.5822 9.47909 13.9276C10.4679 12.9387 11.4986 13.1337 11.4986 12.493C11.4986 12.0195 10.6908 11.8802 10.1337 11.3231C9.63229 10.8217 9.32589 10.1811 9.32589 9.42897C9.32589 7.9805 10.5097 6.81059 11.9582 6.81059C12.2367 6.81059 12.4874 6.85237 12.6964 6.85237C13.0724 6.85237 13.2674 6.68524 13.2674 6.42061C13.2674 6.26741 13.1978 6.07242 13.1978 5.86351C13.1978 5.38997 13.6017 5 14.0891 5C14.5766 5 14.9666 5.4039 14.9666 5.89136C14.9666 6.40669 14.5627 6.64345 14.2562 6.75487C14.0056 6.83844 13.8106 6.94986 13.8106 7.20056C13.8106 7.67409 14.6741 8.1337 14.6741 9.45682ZM14.3955 16.4485C14.3955 15.0696 13.3788 13.9554 12 13.9554C10.6212 13.9554 9.60444 15.0696 9.60444 16.4485C9.60444 17.8134 10.6212 18.9415 12 18.9415C13.3788 18.9415 14.3955 17.8134 14.3955 16.4485ZM13.5738 9.42897C13.5738 8.55153 12.8635 7.8273 12 7.8273C11.1365 7.8273 10.4262 8.55153 10.4262 9.42897C10.4262 10.3064 11.1365 11.0306 12 11.0306C12.8635 11.0306 13.5738 10.3064 13.5738 9.42897Z",
    fill: "#FEFDFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23783_290968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23783_290968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.15877,
    height: 15,
    fill: "white",
    transform: "translate(8.42059 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenhouse);
export default __webpack_public_path__ + "static/media/Greenhouse.c61e052a9594fb4185b9a0f5c2c5c7fe.svg";
export { ForwardRef as ReactComponent };